import React, { useState, useEffect, useRef } from "react";
import { db } from "./firebaseConfig"; // Importa a instância do Firestore
import {collection, query, where, onSnapshot, getDocs, doc, setDoc} from "firebase/firestore";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import notificationSound from "./assets/chamando_garcom.mp3";
import { FaBell, FaBellSlash } from "react-icons/fa";
import AvaliacaoGarcom from "./components/AvaliacaoGarcom";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";




function ClienteScreen() {
  const [mesa, setMesa] = useState("");
  const [pulseira, setPulseira] = useState("");
  const [chamando, setChamando] = useState(false);
  const [solicitandoConta, setSolicitandoConta] = useState(false);
  const [statusMensagem, setStatusMensagem] = useState("");
  const [dadosSalvos, setDadosSalvos] = useState(false);
  const [somAtivado, setSomAtivado] = useState(true);
  const [mesaInvalida, setMesaInvalida] = useState(false);
  const [garcomAtendimento, setGarcomAtendimento] = useState(null);
  const [avaliacaoEnviada, setAvaliacaoEnviada] = useState(false);
  const [setor, setSetor] = useState("");
  const [pulseiraInvalida, setPulseiraInvalida] = useState(false);
  const [mostrarAvaliacao, setMostrarAvaliacao] = useState(false);
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
  const [abaAtiva, setAbaAtiva] = useState("cardapio");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [piscar, setPiscar] = useState(true);
  const cliqueBloqueadoRef = useRef(false);
  const pulsando = abaAtiva === "atendimento";


  const isAtendimento = abaAtiva === "atendimento";

const textoBotao = isAtendimento
  ? "Acesse nosso cardápio"
  : "Chamar Atendimento";

const iconeBotao = isAtendimento
  ? "fas fa-utensils"
  : "fas fa-bell";

const handleClick = () => {
  setAbaAtiva(isAtendimento ? "cardapio" : "atendimento");
};





  const mostrarNotificacaoFinalizada = (garcom) => {
    toast.success(`✅ Atendimento finalizado por ${garcom}.`, {
      position: "top-right", // Posição da notificação
      autoClose: 3000, // Fecha automaticamente após 3 segundos
      hideProgressBar: false, // Exibe a barra de progresso
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light", // Alternativas: "dark", "colored"
    });
  };
  

  // Alternar som
  const alternarSom = () => {
    setSomAtivado((prev) => !prev); // 🔄 Alterna entre ativado e desativado
  };

  // Tocar som de notificação
  const playNotificationSound = async () => {
    if (!somAtivado) return; // 🔇 Não reproduz se o som estiver desativado
  
    try {
      const audio = new Audio(notificationSound);
      audio.currentTime = 0;
      await audio.play();
    } catch (error) {
      console.error("Erro ao reproduzir o som:", error);
    }
  };
  

  const intervalosPorSetor = {
    Deck: { min: 100, max: 199 },
    Salao: { min: 200, max: 299 },
    PeNaAreia: { min: 300, max: 399 },
    Piscina: { min: 700, max: 799 },
    Lounge: { min: 500, max: 599 },
  };

  const validarMesa = (numeroMesa) => {
    return Object.values(intervalosPorSetor).some(
      (intervalo) => numeroMesa >= intervalo.min && numeroMesa <= intervalo.max
    );
  };

  const detectarSetor = (numeroMesa) => {
    for (const [setor, intervalo] of Object.entries(intervalosPorSetor)) {
      if (numeroMesa >= intervalo.min && numeroMesa <= intervalo.max) {
        return setor;
      }
    }
    return "Fora dos Setores";
  };

// 🔔 Função para formatar data e hora atual no fuso horário local
const formatarDataHoraAtual = () => {
  const now = new Date();
  
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Meses são baseados em zero
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0'); // Hora local correta
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};


// ✅ Função genérica para criar solicitações (chamada ou conta)
const criarSolicitacao = async (tipo, pulseiraOverride = null) => {
  if (cliqueBloqueadoRef.current) return;

  cliqueBloqueadoRef.current = true;
  setBotaoDesabilitado(true);

  const numeroMesa = parseInt(mesa, 10);

if (!validarMesa(numeroMesa)) {
  setMesaInvalida(true);
  setStatusMensagem("Por favor, insira um número de mesa válido dentro dos setores permitidos.");

  cliqueBloqueadoRef.current = false;
  setBotaoDesabilitado(false);
  return;
}

  setMesaInvalida(false);
  const setorDetectado = detectarSetor(numeroMesa);
  const dataHoraAtual = formatarDataHoraAtual();

// 🚫 Verifica se já existe uma solicitação pendente ou em andamento para a mesma mesa e tipo
const q = query(
  collection(db, "chamadas"),
  where("mesa", "==", numeroMesa),
  where("tipo", "==", tipo),
  where("status", "in", ["pendente", "em_andamento"]) // ✅ Verifica pendente OU em andamento
);
let existingCalls;

try {
  existingCalls = await getDocs(q);
} catch (error) {
  console.error("Erro ao verificar chamadas existentes:", error);
  setStatusMensagem("Erro ao verificar solicitação existente. Tente novamente.");

  cliqueBloqueadoRef.current = false;
  setBotaoDesabilitado(false);
  return;
}

if (!existingCalls.empty) {
  setStatusMensagem(
    `Já existe uma ${tipo === "chamada" ? "chamada" : "solicitação de conta"} em andamento para esta mesa.`
  );

  // mantém bloqueado porque já existe uma solicitação ativa
  setBotaoDesabilitado(true);
  return;
}


  const idSolicitacao = uuidv4(); // 🔑 Gera um ID único e string
  const solicitacao = {
    id: idSolicitacao,
    mesa: numeroMesa,
    pulseira: pulseiraOverride ?? pulseira ?? "",
    setor: setorDetectado || "Setor Não Detectado",
    status: "pendente",
    tipo: tipo,
    data_hora: dataHoraAtual,
    
  };

  try {
    // ✅ Cria o documento com o ID gerado
    await setDoc(doc(db, "chamadas", idSolicitacao), solicitacao);

    if (tipo === "chamada") {
      setChamando(true);
      setStatusMensagem(`Solicitação enviada ao garçom do setor ${setorDetectado}. Aguarde...`);
      setDadosSalvos(true);
    } else if (tipo === "conta") {
      setSolicitandoConta(true);
      setStatusMensagem(`💵 Solicitação de conta enviada ao garçom do setor ${setorDetectado}. Aguarde...`);
    }

} catch (error) {
  console.error(`Erro ao enviar solicitação (${tipo}):`, error);
  setStatusMensagem(`Erro ao enviar solicitação de ${tipo}. Tente novamente.`);

  cliqueBloqueadoRef.current = false;
  setBotaoDesabilitado(false);
}
};

// 📞 Função para chamar o garçom
const chamarGarcom = () => criarSolicitacao("chamada");

// 💵 Função para solicitar a conta
const solicitarConta = async () => {
  const numeroMesa = parseInt(mesa, 10);

  if (!numeroMesa || isNaN(numeroMesa) || !validarMesa(numeroMesa)) {
    Swal.fire({
      icon: 'warning',
      title: 'Número da mesa inválido',
      text: 'Por favor, digite um número de mesa válido antes de solicitar a conta.',
    });
    return;
  }

  let pulseiraFinal = pulseira;

  // 🔥 Se não tiver pulseira, abre o Swal
  if (!pulseiraFinal || parseInt(pulseiraFinal, 10) <= 0 || parseInt(pulseiraFinal, 10) > 999) {
    const { value, isConfirmed } = await Swal.fire({
      title: 'Informe o número da pulseira',
      input: 'number',
      inputLabel: 'Digite o número da sua pulseira',
      inputAttributes: {
        min: "1",
        max: "999",
        step: "1",
      },
      inputValidator: (value) => {
        if (!value || parseInt(value, 10) < 1 || parseInt(value, 10) > 999) {
          return 'Número inválido!';
        }
        return null;
      },
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    });

    if (!isConfirmed || !value) {
      toast.error("Você precisa informar a pulseira para solicitar a conta.");
      return;
    }

    pulseiraFinal = value;
    setPulseira(value);
  }

  // ✅ AGORA FUNCIONA SEM ERRO
  criarSolicitacao("conta", pulseiraFinal);
};


//piscar botão entre chamar atendimento e cardapio
useEffect(() => {
  const interval = setInterval(() => {
    setPiscar(true);

    setTimeout(() => {
      setPiscar(false);
    }, 1000);
  }, 3000);

  return () => clearInterval(interval);
}, []);




// 🎯 Validação instantânea ao digitar a mesa
useEffect(() => {
  const numeroMesa = parseInt(mesa, 10);
  if (!isNaN(numeroMesa) && validarMesa(numeroMesa)) {
    setMesaInvalida(false);
    setStatusMensagem("");
  }
}, [mesa]);

// ✅ Link da pesquisa de satisfação
const pesquisaURL = "https://qrco.de/bgdR6X"; // Substitua pelo link real
// 🔗 Abrir pesquisa de satisfação em nova guia
const abrirPesquisaSatisfacao = () => {
  window.open(pesquisaURL, "_blank", "noopener,noreferrer");
};

// Listener para atualizações na coleção "chamadas"
useEffect(() => {
  if (mesa) {
    const q = query(
      collection(db, "chamadas"),
      where("mesa", "==", parseInt(mesa, 10))
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "modified") {
          const data = change.doc.data();
          setChamando(false);

          // ✅ Se o garçom aceitou a chamada → Desabilita os botões
          if (data.status === "em_andamento" && data.garcom) {
            const nomeFormatado = data.garcom.split(' ')[0] + ' ' + data.garcom.split(' ').slice(-1)[0];
            setStatusMensagem(`Sua solicitação foi aceita. Por gentileza aguarde, ${nomeFormatado} está a caminho.`);

            setBotaoDesabilitado(true); // 🔒 Desabilita os botões
            playNotificationSound(); // 🔊 Toca o som APENAS ao aceitar

            // 🔗 Se for uma solicitação de conta, redireciona para a pesquisa
            if (data.tipo === "conta") {
              Swal.fire({
                title: "Solicitação de conta aceita!",
                text: "Você será redirecionado para uma pesquisa de satisfação enquanto aguarda.",
                icon: "success",
                timer: 5000,
                showConfirmButton: false,
              }).then(() => {
                window.location.href = pesquisaURL; // 🚀 Redireciona para a pesquisa
              });
            }
          } 
          
          // ✅ Se o atendimento foi finalizado → Habilita os botões
else if (data.status === "finalizado") {
  const nomeFormatado = data.garcom
    ? `${data.garcom.split(' ')[0]} ${data.garcom.split(' ').slice(-1)[0]}`
    : "um garçom";

  setStatusMensagem(`✅ Atendimento finalizado por ${nomeFormatado}.`);

  cliqueBloqueadoRef.current = false;
  setBotaoDesabilitado(false);
}
          
          // ✅ Caso padrão
          else {
            setStatusMensagem(data.mensagem || "Atualização recebida.");
          }

          
        }
      });
    });

    return () => unsubscribe(); // 🧹 Limpeza ao desmontar
  }
}, [mesa, pulseira, somAtivado]);




  const setorNomesAmigaveis = {
    Deck: "Deck",
    Salao: "Salão",
    PeNaAreia: "Pé na Areia",
    Piscina: "Piscina",
    Lounge: "Lounge",
  };

return (
  <>
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ paddingTop: "20px", paddingBottom: "90px", minHeight: "100vh" }}
    >
<div
  className="card shadow-lg w-100"
  style={{
    maxWidth: "100%", // Remove limite de 600px
    width: "100%",
    borderRadius: "16px",
    border: "none",
    backgroundColor: "#f8f9fa",
    minHeight: "75vh",
    margin: "0 auto",
    padding: "16px 8px", // padding lateral menor
    boxSizing: "border-box",
  }}
>



{/* Aba Atendimento */}
<div
  style={{
    display: abaAtiva === "atendimento" ? "block" : "none",
    padding: "16px",
    paddingBottom: "110px", // espaço pro menu fixo inferior
    minHeight: "calc(100vh - 90px)",
    boxSizing: "border-box",
    backgroundColor: "#f1f3f5",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
  }}
>
<div
  className="card shadow-lg"
  style={{
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "24px 20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }}
>
  <h2
    className="text-center"
    style={{
      fontWeight: 700,
      fontSize: "25px",
      color: "#222",
      marginBottom: "24px",
    }}
  >
    Solicitação de Atendimento
  </h2>

  {/* CAMPO NÚMERO DA MESA */}
  {!dadosSalvos && (
    <div className="mb-4">
      <label
        htmlFor="mesa"
        className="form-label"
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: "#222",
          marginBottom: "6px",
        }}
      >
        NÚMERO DA MESA <span className="text-danger">*</span>
      </label>
      <input
        type="text"
        id="mesa"
        className={`form-control ${mesaInvalida ? "is-invalid" : ""}`}
        value={mesa}
        onChange={(e) => {
          const valor = e.target.value.replace(/\D/g, "");
          if (valor.length <= 3) {
            setMesa(valor);
            const numeroMesa = parseInt(valor, 10);
            if (!isNaN(numeroMesa) && validarMesa(numeroMesa)) {
              setMesaInvalida(false);
              setSetor(detectarSetor(numeroMesa));
            } else {
              setMesaInvalida(true);
            }
            if (valor === "") setMesaInvalida(false);
          }
        }}
        onBlur={() => {
          const numeroMesa = parseInt(mesa, 10);
          setMesaInvalida(isNaN(numeroMesa) || !validarMesa(numeroMesa));
        }}
        placeholder="Digite o número da mesa"
        disabled={chamando || solicitandoConta}
        style={{
          borderRadius: "8px",
          padding: "10px",
          fontSize: "15px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      />
      {mesaInvalida && mesa !== "" && (
        <div className="invalid-feedback" style={{ fontSize: "12px" }}>
          O número da mesa é inválido!
        </div>
      )}
    </div>
  )}

{/* BOTÕES DE AÇÃO */}
<div className="d-grid gap-3 mb-4">

  {/* 🟢 CHAMAR GARÇOM (PRINCIPAL) */}
  <button
    className={`btn btn-lg ${chamando ? "btn-secondary" : ""}`}
    onClick={chamarGarcom}
    disabled={botaoDesabilitado || chamando || solicitandoConta}
    style={{
      backgroundColor: chamando ? "#6c757d" : "#19a319",
      color: "#fff",
      fontSize: "18px",
      padding: "14px",
      fontWeight: "700",
      borderRadius: "10px",
      border: "none",
      boxShadow: "0 4px 10px rgba(34,197,94,0.3)",
    }}
  >
    <i className="fas fa-bell me-2"></i>
    {botaoDesabilitado ? "Aguarde..." : chamando ? "Chamando..." : "Chamar Garçom"}
  </button>

  {/* 🔵 SOLICITAR CONTA */}
  <button
    className={`btn btn-lg ${solicitandoConta ? "btn-secondary" : ""}`}
    onClick={solicitarConta}
    disabled={botaoDesabilitado || chamando || solicitandoConta}
    style={{
      backgroundColor: solicitandoConta ? "#6c757d" : "#eb6e25",
      color: "#fff",
      fontSize: "18px",
      padding: "14px",
      fontWeight: "600",
      borderRadius: "10px",
      border: "none",
      boxShadow: "0 4px 10px rgba(37,99,235,0.3)",
    }}
  >
    <i className="fas fa-money-check-alt me-2"></i>
    {botaoDesabilitado ? "Aguarde..." : solicitandoConta ? "Solicitando..." : "Solicitar Conta"}
  </button>

  {/* 🟠 AVALIAÇÃO */}
  <button
    className="btn btn-lg w-100"
    onClick={abrirPesquisaSatisfacao}
    style={{
      backgroundColor: "#f59e0b",
      color: "#fff",
      fontSize: "17px",
      padding: "12px",
      fontWeight: "600",
      borderRadius: "10px",
      border: "none",
      boxShadow: "0 4px 10px rgba(245,158,11,0.3)",
    }}
  >
    <i className="fas fa-star me-2"></i>
    Avalie o Atendimento
  </button>

</div>



  {/* LOCALIZAÇÃO EXIBIDA 
  {(mesa || pulseira) && (
    <div
      className="alert alert-light text-center"
      style={{
        padding: "8px 12px",
        fontSize: "14px",
        maxWidth: "300px",
        margin: "0 auto 20px",
        borderRadius: "8px",
      }}
    >
      <h5 style={{ fontSize: "16px", marginBottom: "8px" }}>Localização</h5>
      {mesa && <p style={{ margin: "0" }}><strong>Mesa:</strong> {mesa}</p>}
      {pulseira && <p style={{ margin: "0" }}><strong>Pulseira:</strong> {pulseira}</p>}
    </div>
  )}

*/}

  {/* MENSAGEM DE STATUS */}
  {statusMensagem && (
    <div
      className="alert alert-info text-center"
      style={{
        fontSize: "18px",
        fontWeight: "500",
        borderRadius: "8px",
        padding: "8px 12px",
        maxWidth: "300px",
        margin: "0 auto 20px",
      }}
    >
      {statusMensagem}
      {garcomAtendimento && (
        <p className="mt-2" style={{ fontSize: "16px", color: "#007bff" }}>
          <strong>{garcomAtendimento}</strong>
        </p>
      )}
    </div>
  )}


  {/* CONTROLE DE SOM 
  <div className="text-center">
    <p
      style={{
        fontWeight: 500,
        fontSize: "15px",
        color: "#555",
        marginBottom: "12px",
      }}
    >
      Deseja receber notificações sonoras ao ser atendido?
    </p>

    <button
      onClick={alternarSom}
      title={somAtivado ? "Desativar som" : "Ativar som"}
      style={{
        backgroundColor: somAtivado ? "#082919" : "#dc3545",
        color: "#fff",
        border: "none",
        borderRadius: "12px",
        padding: "10px 20px",
        fontSize: "16px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        width: "100%",
        maxWidth: "300px",
        margin: "0 auto",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        transition: "all 0.2s ease-in-out",
      }}
    >
      <i className={`fas ${somAtivado ? "fa-volume-up" : "fa-volume-mute"}`}></i>
      {somAtivado ? "Som Ativado" : "Som Desativado"}
    </button>
  </div>
  */}
</div>
</div>

{/* Aba Cardápio */}
<div
  style={{
    visibility: abaAtiva === "cardapio" ? "visible" : "hidden",
    height: abaAtiva === "cardapio" ? "auto" : "0",
    position: abaAtiva === "cardapio" ? "relative" : "absolute",
    width: "100%",
    padding: "0px",
    paddingBottom: "80px",
    boxSizing: "border-box",
    overflow: "hidden",
  }}
>

  <h2
    className="text-center mb-3"
    style={{
      fontWeight: "bold",
      fontSize: "22px",
      color: "#333",
    }}
  >
    CARDÁPIO
  </h2>

  {!iframeLoaded && (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "300px" }}
    >
      <div className="spinner-border text-primary" />
    </div>
  )}

  <div
    style={{
      width: "100%",
      height: "calc(100vh - 160px)",// altura segura considerando menu inferior
      overflow: "hidden",
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      backgroundColor: "#fff",
    }}
  >
    <iframe
      src="https://livemenu.app/menu/68b0af65a7e21605e132ac3b?cross_session=done"
      title="Cardápio"
      width="100%"
      height="100%"
      style={{
        border: "none",
        display: iframeLoaded ? "block" : "none",
      }}
      scrolling="yes"
      onLoad={() => setIframeLoaded(true)}
    ></iframe>
  </div>
</div>



      </div>
    </div>

{/* Barra fixa inferior */}
<div
  style={{
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "10px 15px",
    backgroundColor: "#fff",
    boxShadow: "0 -2px 10px rgba(0,0,0,0.08)",
    zIndex: 1000,
  }}
>
  <button
    onClick={handleClick}
    style={{
      width: "100%",
      backgroundColor: abaAtiva === "atendimento" ? "#007bff" : "#0e550e",
      color: "#fff",
      border: "none",
      borderRadius: "12px",
      padding: "16px",
      fontSize: "17px",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",

      // 🔥 efeito visual
      boxShadow: pulsando
        ? "0 0 20px rgba(0,123,255,0.6)"
        : piscar
        ? "0 0 20px rgba(40,167,69,0.9)"
        : "0 6px 15px rgba(0,0,0,0.15)",

      // 🔥 piscar (somente fora do atendimento)
      transform: piscar ? "scale(1.05)" : "scale(1)",

      // 🔥 pulsar contínuo (somente no atendimento)
      animation: pulsando ? "pulseSoft 2s infinite" : "none",

      transition: "all 0.3s ease",
    }}
  >
    <i className={iconeBotao}></i>
    {textoBotao}
  </button>
</div>
  </>
);




}

export default ClienteScreen;
